var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"super-up-class"}},[_c('div',{staticClass:"tab"},[_c('span',{staticClass:"span1"}),_c('span',{staticClass:"span2"}),_c('span',{staticClass:"span3"})]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"left"}),_c('div',{staticClass:"right"})])])
}]

export { render, staticRenderFns }